import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import OutbOrd07Actions, { OutbOrd07Types } from '../Stores/OutbOrd07/Actions';

const getAppStore = state => state.app;

export function* outbOrd07FetchOutbOrd07({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(OutbOrd07Actions.outbOrd07FetchOutbOrd07Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `outbOrd/indexProcess/OUTB_ORD_07/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        OutbOrd07Actions.outbOrd07FetchOutbOrd07Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd07Actions.outbOrd07FetchOutbOrd07Loading(false));
  }
}

export function* outbOrd07CreateOutbOrd07({ hdrIds }) {
  try {
    yield put(OutbOrd07Actions.outbOrd07CreateOutbOrd07Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `outbOrd/createProcess/OUTB_ORD_07`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(OutbOrd07Actions.outbOrd07CreateOutbOrd07Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd07Actions.outbOrd07CreateOutbOrd07Loading(false));
  }
}

export function* outbOrd07GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/trfOrdDetail/update/${hdrId}`));
}

export function* outbOrd07NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/trfOrdDetail/create/${app.curDivisionId}/TRANSFER_TO_VAN`));
}

export function* outbOrd07CheckStock({ hdrIds }) {
  try {
    yield put(OutbOrd07Actions.outbOrd07CreateOutbOrd07Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `trfOrd/checkStock`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'CHECK_STOCK.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(OutbOrd07Actions.outbOrd07CreateOutbOrd07Loading(false));
  }
}

export const saga = [
  takeLatest(OutbOrd07Types.OUTB_ORD07_FETCH_OUTB_ORD07, outbOrd07FetchOutbOrd07),
  takeLatest(OutbOrd07Types.OUTB_ORD07_CREATE_OUTB_ORD07, outbOrd07CreateOutbOrd07),
  takeLatest(OutbOrd07Types.OUTB_ORD07_GO_TO_DOCUMENT, outbOrd07GoToDocument),
  takeLatest(OutbOrd07Types.OUTB_ORD07_NEW_DOCUMENT, outbOrd07NewDocument),
  takeLatest(OutbOrd07Types.OUTB_ORD07_CHECK_STOCK, outbOrd07CheckStock)
];
